import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { EmailSenderObservable } from "@/store/email-senders/EmailSenderObservable";
import { TextMessageSenderObservable } from "@/store/text-message-senders/TextMessageSenderObservable";
import {
  MDSText,
  MDSTextVariant,
  MDSButton,
  MDSButtonVariant,
  MDSModalDialog,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSButtonGroup,
} from "@/mds";

type TProps = {
  itemToDelete: EmailSenderObservable | TextMessageSenderObservable | null;
  setItemToDelete: (
    itemToDelete: EmailSenderObservable | TextMessageSenderObservable | null
  ) => void;
};

export const DeleteItemModal = observer<TProps>(({ itemToDelete, setItemToDelete }) => {
  const { store } = useAppStore();
  const integrationStore =
    itemToDelete instanceof EmailSenderObservable ? store.emailSenders : store.textMessageSenders;
  const isEmail = itemToDelete instanceof EmailSenderObservable;

  const isModalOpen = !!itemToDelete;
  const { id } = itemToDelete ?? {};

  const handleCloseModal = () => {
    setItemToDelete(null);
  };

  const handleDeleteItem = () => {
    setItemToDelete(null);

    if (!id) {
      return;
    }

    integrationStore.delete(id);
  };

  return (
    <MDSModalDialog isOpen={isModalOpen} handleClose={handleCloseModal}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        Are you sure you want to {isEmail ? "delete" : "remove"} “{itemToDelete?.input ?? "this"}
        ”?
      </MDSText>

      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>
          {isEmail
            ? "Deletion is permanent and cannot be undone"
            : "You'll have to re-verify this phone number if you add it in the future"}
        </MDSText>
      </MDSDialogTextContent>

      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={handleCloseModal}>Cancel</MDSButton>
        <MDSButton variant={MDSButtonVariant.DangerFilled} onClick={handleDeleteItem}>
          {isEmail ? "Delete forever" : "Remove"}
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
